import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductDetail from "../pages/product-detail/page";
import Search from "../pages/search/page";
import About from "../pages/about/page";
import Privacy from "../pages/privacy/page";
import Terms from "../pages/terms/page";
import Contact from "../pages/contact/page";
import Guides from "../pages/guides/page";
import GuideDetail from "../pages/guide-detail/page";
import EditorsPicks from "../pages/editors-picks/page";
import Admin from "../pages/admin/page";
import Wishlist from "../pages/wishlist/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/product/:id",
    element: <ProductDetail />,
  },
  {
    path: "/search",
    element: <Search />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/guides",
    element: <Guides />,
  },
  {
    path: "/guides/:id",
    element: <GuideDetail />,
  },
  {
    path: "/editors-picks",
    element: <EditorsPicks />,
  },
  {
    path: "/wishlist",
    element: <Wishlist />,
  },
  {
    path: "/admin",
    element: <Admin />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;